//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import ProductDistributionCell from "@/pages/FlashReport/components/ProductDistributionCell";

const DEFAULT_FORMAT = (value) =>
  value != null && value != undefined ? value : "N/A";

export default {
  name: "ProductDistributionTable",
  props: [
    "tableClass",
    "bordered",
    "data",
    "recordsTotal",
    "loading",
    "productLevel",
  ],
  components: {
    Table,
  },
  mounted: function () {},
  data: function () {
    return {
      separator: "horizontal",
      columns: [
        {
          name: "product-hierarchy",
          required: false,
          label: this.productLevel,
          align: "left",
          field: (row) => (row.product ? row.product.name : "N/A"),
          format: DEFAULT_FORMAT,
          sortable: false,
          component: {
            element: ProductDistributionCell,
            props: {
              value: "value"
            }
          }
        },
        {
          name: "stores-number",
          required: false,
          label: "Nº Lojas c/ Vendas",
          align: "left",
          field: (row) => (row.product ? row.product.store_count : "N/A"),
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "numeric-distribution",
          required: false,
          label: "DN %",
          align: "left",
          field: (row) => (row.dn ? row.dn : "N/A"),
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "pondered-distribution",
          required: false,
          label: "DP %",
          align: "left",
          field: (row) => (row.dp ? row.dp : "N/A"),
          format: DEFAULT_FORMAT,
          sortable: false,
        },
      ],
    };
  },
  methods: {},
};
